module.exports = __webpack_public_path__ + "img/circle_help_white.0d8bacdf.png";